{
  "id": "campaign-148",
  "name": "Golden Vale II",
  "seed": "campaign:148",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".,......T......mmm..",
    ".....#....T.....m...",
    "....................",
    ".....x..............",
    ".T..........T......x",
    "........T...........",
    "....................",
    "...................T",
    "..,..........T..,...",
    "T.........#....,,...",
    "..,......#..........",
    "....................",
    "x...x..............#",
    "....................",
    "..#.......Y....x.h..",
    "#.............x...x.",
    "....................",
    "....................",
    "S....T......T...x..."
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 12,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 0,
      "y": 3
    },
    {
      "kind": "deer",
      "x": 0,
      "y": 2
    },
    {
      "kind": "deer",
      "x": 9,
      "y": 5
    },
    {
      "kind": "deer",
      "x": 9,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 19,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 9
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 13
    },
    {
      "kind": "rare",
      "x": 19,
      "y": 0
    },
    {
      "kind": "repair",
      "x": 15,
      "y": 11
    }
  ],
  "hills": [
    {
      "x": 6,
      "y": 3,
      "w": 7,
      "h": 7
    },
    {
      "x": 14,
      "y": 4,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 148,
  "biome": "meadow",
  "par": {
    "reel": 13447,
    "push": 11894,
    "selfPropelled": 10860,
    "tractor": 8945,
    "zeroTurn": 7674,
    "fairway": 4433
  },
  "goldTime": {
    "reel": 13447,
    "push": 11894,
    "selfPropelled": 10860,
    "tractor": 8945,
    "zeroTurn": 7674,
    "fairway": 4195
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 11,
      "selfPropelled": 10,
      "tractor": 10,
      "zeroTurn": 0,
      "fairway": 10
    },
    "gold": {
      "reel": 10,
      "push": 11,
      "selfPropelled": 10,
      "tractor": 10,
      "zeroTurn": 0,
      "fairway": 33
    }
  }
}
